import script from "./FeaturedView.vue?vue&type=script&setup=true&lang=js"
export * from "./FeaturedView.vue?vue&type=script&setup=true&lang=js"

import "./FeaturedView.vue?vue&type=style&index=0&id=f1b6aa58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1b6aa58"]])

export default __exports__